export default __webpack_public_path__ + "static/media/client2.c85a84f0.jpg";